<app-popup-banner></app-popup-banner>

<section class="position-relative">
  <section class="hero-wrapper position-relative">
    <app-cover-hero-banner></app-cover-hero-banner>
  </section>
</section>

<div class="bg-transparent">
  <app-home-about></app-home-about>
  <app-home-our-properties></app-home-our-properties>
  <app-home-upcoming-properties></app-home-upcoming-properties>

  <section class="core-values-container py-5">
    <div class="container text-center">
      <app-section-title [inital]="title" [iscursive]="true" [title]="'Our Values'"
        [subtitle]="'The Udaan Essence'"></app-section-title>

      <div class="values-wrapper py-4" [class.overlay-active]="activeKey">
        <div class="values-container">
          <div class="value-card" [class.active]="activeKey === 'goodstay'" (mouseenter)="onHover('goodstay')"
            (mouseleave)="onHover(null)" (touchstart)="onTouch($event, 'goodstay')"
            (click)="onClick($event, 'goodstay')">
            <h3 class="core-title-static">
              <img src="assets/images/icons/bed.svg" class="core-image" alt="values-icon" />
              #goodstay
            </h3>

            <div class="card-overlay">
              <video autoplay muted loop playsinline webkit-playsinline preload="metadata" class="overlay-video"
                src="https://txl-videos.s3.ap-south-1.amazonaws.com/udaan-videos/good_stay.mp4"></video>

              <div class="overlay-text">
                <img class="hover-logo" src="assets/images/icons/bed.svg" alt="values-icon" />
                <h3>#goodstay</h3>
                <p>Embrace a timeless elegance with refined excellence.</p>
              </div>
            </div>
          </div>

          <div class="value-card" [class.active]="activeKey === 'goodfood'" (mouseenter)="onHover('goodfood')"
            (mouseleave)="onHover(null)" (touchstart)="onTouch($event, 'goodfood')"
            (click)="onClick($event, 'goodfood')">
            <h3 class="core-title-static">
              <img src="assets/images/icons/food-tray.svg" class="core-image" alt="values-icon" />
              #goodfood
            </h3>

            <div class="card-overlay">
              <video autoplay muted loop playsinline webkit-playsinline preload="metadata" class="overlay-video"
                src="https://txl-videos.s3.ap-south-1.amazonaws.com/udaan-videos/good_foods.mp4"></video>

              <div class="overlay-text">
                <img class="hover-logo" src="assets/images/icons/food-tray.svg" alt="values-icon" />
                <h3>#goodfood</h3>
                <p>Indulge in unforgettable taste and culinary hospitality.</p>
              </div>
            </div>
          </div>

          <div class="value-card" [class.active]="activeKey === 'goodpeople'" (mouseenter)="onHover('goodpeople')"
            (mouseleave)="onHover(null)" (touchstart)="onTouch($event, 'goodpeople')"
            (click)="onClick($event, 'goodpeople')">
            <h3 class="core-title-static">
              <img src="assets/images/icons/people.svg" class="core-image" alt="values-icon" />
              #goodpeople
            </h3>

            <div class="card-overlay">
              <video autoplay muted loop playsinline webkit-playsinline preload="metadata" class="overlay-video"
                src="https://txl-videos.s3.ap-south-1.amazonaws.com/udaan-videos/good_people.mp4"></video>

              <div class="overlay-text">
                <img class="hover-logo" src="assets/images/icons/people.svg" alt="values-icon" />
                <h3>#goodpeople</h3>
                <p>Experience genuine service and heartfelt interactions.</p>
              </div>
            </div>
          </div>
        </div>

        <div class="values-hover-overlay" id="values-hover-overlay">
          <video autoplay muted loop playsinline webkit-playsinline preload="metadata" class="overlay-video"
            id="video-goodstay" src="https://txl-videos.s3.ap-south-1.amazonaws.com/udaan-videos/good_stay.mp4"></video>

          <video autoplay muted loop playsinline webkit-playsinline preload="metadata" class="overlay-video"
            id="video-goodfood"
            src="https://txl-videos.s3.ap-south-1.amazonaws.com/udaan-videos/good_foods.mp4"></video>

          <video autoplay muted loop playsinline webkit-playsinline preload="metadata" class="overlay-video"
            id="video-goodpeople"
            src="https://txl-videos.s3.ap-south-1.amazonaws.com/udaan-videos/good_people.mp4"></video>

          <div class="overlay-text">
            <img id="hover-logo" class="hover-logo" />
            <h3 id="hover-title"></h3>
            <p id="hover-desc"></p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="hotel-diaries-section pb-5">
    <div class="container mt-4">
      <app-hotel-diaries />
    </div>
  </section>

  <section>
    <div class="container my-5 position-relative">
      <app-section-title [inital]="title" [iscursive]="true" [title]="'FAQs'"
        [subtitle]="'EVERYTHING YOU NEED TO KNOW'"></app-section-title>

      <div class="view-all-btn-wrapper">
        <button class="txl-button secondary view-all-btn" (click)="viewAllFAQ()">
          View All
        </button>
      </div>

      <app-faq [data]="dataFAQ"></app-faq>
    </div>
  </section>

  <!-- <section class="mt-5">
    <div class="container">
      <app-services-section></app-services-section>
    </div>
  </section> -->

  <app-scroll-to-top></app-scroll-to-top>
</div>